import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatDialog } from '@angular/material';
import { DataService } from 'src/app/services/data.service';
import { AddMajorComponent } from '../add-major/add-major.component';
import { AuthService } from 'src/app/auth/auth.service';
import { List } from 'src/app/stores/administrator/list.store';
import { AuthStore } from 'src/app/stores/auth/auth.store';

@Component({
  selector: 'app-faculty-panel',
  templateUrl: './faculty-panel.component.html',
  styleUrls: ['./faculty-panel.component.scss']
})
export class FacultyPanelComponent implements OnInit {
  SELECTED_FACULTY: any;
  SELECTED_TERM: any;
  FACULTIES: any[] = [];

  ID: string;
  LOADING: boolean = true;
  constructor(
    private auth: AuthStore,
    private route: ActivatedRoute,
    private router: Router,
    public store: List,
    private ds: DataService,
    public dialog: MatDialog) { }

  create(event) {
    const dialogRef = this.dialog.open(AddMajorComponent, {
      data: null,
      panelClass: 'register-test-overlay-panel',
      width: '30vw',
      height: '100vh',
      disableClose: false,
      role: 'dialog',
    });
    dialogRef.updatePosition({ top: '0', right: '0', bottom: '0' });
    dialogRef.afterClosed().subscribe(result => { });
  }

  async ngOnInit() {
    const config = await this.auth.fetchEnvironment();
    const { termRef } = config;
    this.SELECTED_TERM = await this.store.fetchItemRef(termRef)
    this.route.params.subscribe(async params => {
      this.LOADING = true;
      const { id } = params;
      this.ID = id;
      this.SELECTED_FACULTY = await this.store.fetchSelected(this.ds.facultyRef(), id);
      this.FACULTIES = await this.store.fetchList(this.ds.facultyRef(ref => ref.orderBy('name')));
      this.LOADING = false;
    })
  }

  // ngOnDestroy() {
  //   this.store.dispost();
  // }

  _goBack() {
    this.router.navigate(['/app/faculties/data'])
  }



}
